module.exports = __webpack_public_path__ + "media/images/map-placeholder-e895f03d34596537c86715bb08ee9618.jpg";